export const config = {
    radius: 6,
    ratio: 100,
}
